import { Typography, Card, Button } from 'antd';
import { format } from 'date-fns';
import FileSaver from 'file-saver';
import React, { useState, useEffect } from 'react';

import GiftCodeTable from '@/GiftCode/components/GiftCodeTable';
import { useGacha } from '@/hooks/context/GachaContext';
import { useGiftCodeCrypto } from '@/hooks/context/GiftCodeCryptContext';
import { GiftCode } from '@/models/GiftCode';
import { createApiClientWithToken } from '@/service/PreRegistrationApiFactory';

const dateFormat = 'yyyy/MM/dd HH:mm:ss';

const ListGiftCode: React.FC<{}> = () => {
  const api = createApiClientWithToken();
  const [giftCodes, setGiftCodes] = useState<GiftCode[]>([]);
  const { gacha } = useGacha();
  const { giftCodeCrypto } = useGiftCodeCrypto();

  useEffect(() => {
    api.listGiftCode(gacha.id).then((response) => {
      const decryptedGiftCodes = response.map((giftCode) => giftCodeCrypto.decryptGiftCode(giftCode));
      setGiftCodes(decryptedGiftCodes);
    });
  }, []);

  const UnregisterButton = () => {
    const exportCsv = (_giftCodes: GiftCode[]) => {
      const headers = ['コード', '金額'];
      const body = _giftCodes.map((giftCode) => [giftCode.code, giftCode.price]);
      const csvRows = [headers, ...body];
      const csv = csvRows.map((row) => row.join(',')).join('\r\n');

      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, csv], { type: 'text/csv' });
      FileSaver.saveAs(blob, `${gacha.name}-未使用のコード一覧-${format(Date.now(), dateFormat)}.csv`);
    };

    const onClick = async () => {
      // eslint-disable-next-line no-alert, no-restricted-globals
      if (!confirm('使用していないギフトコードの登録を解除しますか？')) {
        return;
      }

      const response = await api.unregisterGiftCode(gacha.id);

      const decryptedGiftCodes = response.map((giftCode) => giftCodeCrypto.decryptGiftCode(giftCode));
      exportCsv(decryptedGiftCodes);

      api.listGiftCode(gacha.id).then((_response) => {
        const newDecryptedGiftCodes = _response.map((giftCode) => giftCodeCrypto.decryptGiftCode(giftCode));
        setGiftCodes(newDecryptedGiftCodes);
      });
    };

    return (
      <Button danger onClick={onClick}>
        未使用のコードの登録解除（CSVエクスポート）
      </Button>
    );
  };

  return (
    <Card
      title={<Typography.Title level={4}>{gacha.name} のギフトコード一覧</Typography.Title>}
      extra={UnregisterButton()}
    >
      <GiftCodeTable giftCodes={giftCodes} />
    </Card>
  );
};

export default ListGiftCode;
